module.exports = __webpack_public_path__ + "img/AGS-04.cbbd332.png";